// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
/**
 * INERT in this portal. The interfaces below are the source's, verbatim; the
 * service is not.
 *
 * xop-edge-staff opens an ActionCable socket to crm-api for live campaign and
 * CSV-import progress. crm-api REFUSES that connection for a reseller, by
 * design and explicitly: `ApplicationCable::Connection#find_verified_user`
 * rejects any token carrying "reseller-portal" as either its `iss` or its
 * `app` claim. /cable is the one surface the reseller wall's Layer 3 route
 * guard cannot reach — ApplicationCable does not include the Authentication
 * concern — so it is closed with a hard refusal instead.
 *
 * A real client here would therefore retry-and-fail on every page load, and
 * `@rails/actioncable` would be a dependency shipped to do nothing. This
 * no-op keeps the two ported consumers (`csv-import-dialog`,
 * `websocket-provider`) compiling and silent: `on()` returns an unsubscribe
 * function so their cleanup effects work, and nothing ever fires.
 */

export interface CampaignUpdate {
  campaign_id: string | number
  status: 'not_sent' | 'scheduled' | 'sending' | 'sent' | 'paused' | 'failed'
  sent_count: number
  delivered_count: number
  recipients_count: number
  updated_at: string
}

export interface ImportProgress {
  status: 'processing' | 'completed' | 'failed' | 'queued'
  message: string
  progress: number
  total: number
  imported: number
  contacts_added?: number
  processed?: number
  errors?: string[]
  warnings?: string[]
  success_rate?: number
  timestamp?: string
}

export interface WebSocketMessage {
  type: 'campaign_status_update' | 'import_progress'
  data: CampaignUpdate | ImportProgress
}

type Unsubscribe = () => void;

class InertWebSocketService {
  connect(): void {
    /* crm-api refuses a reseller-portal token on /cable — see the note above */
  }

  disconnect(): void {
    /* nothing was ever connected */
  }

  /** Returns an unsubscribe, so consumers' cleanup effects behave normally. */
  on(_event: string, _handler: (message: WebSocketMessage) => void): Unsubscribe {
    return () => {
      /* nothing subscribed */
    };
  }

  requestCampaignsUpdate(): void {
    /* campaigns are a marketing surface this portal does not route to */
  }
}

export const webSocketService = new InertWebSocketService();
export default webSocketService;
